import React from 'react';
import {
  FormControl,
  FormControlLabel,
  Select,
  MenuItem,
  ListItemText,
} from '@mui/material';
import PropTypes from 'prop-types';

import { MenuProps } from '../../Assets/js/constant';

function YearSelectorSingle({
  selectedYears,
  label,
  onChange
}) {
  const handleChange = (event) => {
    const newYears = event.target.value;

    let _selectedYears = [],
      _label;
    _label = newYears.toString();
    _selectedYears[0] = newYears;

    onChange({
      selectedYears: _selectedYears,
      label: _label,
    });
  };

  let single_years = [];
  let current_year = new Date().getFullYear();
  for (var i = current_year - 4; i <= current_year + 1; i++) {
    single_years.push(i);
  }
  
  return (
    <div>
      <FormControlLabel
        sx={{
          marginLeft: '0px !important',
          minWidth: 110,
          maxWidth: 300,
          '& .MuiTypography-body1': {
            fontWeight: 'bold',
            fontFamily: 'Verdana !important',
            fontSize: '10pt',
          },
          '& .MuiFormControlLabel-label': {
            marginTop: '2px'
          }
        }}
        variant="standard"
        control={
          <FormControl variant="standard">
            <Select
              sx={{
                marginLeft: '5px',
                marginRight: '20px',
                '& .MuiInputBase-input': {
                  padding: '7px 24px 7px 0',
                },
                '& .MuiSelect-selectMenu': {
                  fontWeight: 'bold',
                  fontFamily: 'Verdana !important',
                  fontSize: '10pt',
                },
              }}
              value={selectedYears[0]}
              onChange={handleChange}
              renderValue={(selected) => label}
              MenuProps={MenuProps}
            >
              {single_years.map((year) => (
                <MenuItem
                  key={year}
                  value={year}
                  sx={{
                    padding: '2px 5px',
                  }}
                >
                  <ListItemText primary={year} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        }
        label="FY : "
        labelPlacement="start"
      />
    </div>
  );
}

YearSelectorSingle.propTypes = {
  selectedYears: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default YearSelectorSingle;
